import styled from 'styled-components'

export const ArrowGraphicOuter = styled.div`
  margin: 0 auto;
  max-width: 1300px;
  box-sizing: border-box;
  .paragraph {
    max-width: 1038px;
    margin: 0 auto;
    padding: 0 1.8rem 8rem;
    @media only screen and (max-width: 1120px) {
      max-width: 734px;
    }
  }
`

export const ArrowGraphicWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: flex-end;

  padding: 0 1.8rem;
  @media only screen and (max-width: 1120px) {
    justify-content: center;
    .bottom-paragarph {
      margin-left: 20px;
    }
  }
  @media only screen and (max-width: 858px) {
    justify-content: center;
  }
`

export const Row = styled.div`
  display: flex;
  .mainImg {
    min-width: 301px;
    max-width: 301px;
  }

  @media only screen and (max-width: 1120px) {
    margin-bottom: 2rem;
  }
  @media only screen and (max-width: 858px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > .para {
      margin-top: 3rem;
      margin-bottom: 1rem;
    }
    .mainImg {
      max-width: 300px;
    }
  }
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    margin-right: 4rem;
  }
  @media only screen and (max-width: 1120px) {
    display: none;
  }
`

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 858px) {
    text-align: center;
  }
  max-width: 849px;
  .para {
    margin-left: 3.4rem;
    @media only screen and (max-width: 858px) {
      margin-left: 0;
    }
  }
`

export const Para = styled.div`
  max-width: 376px;
  > p {
    font-size: 18px;
    @media only screen and (max-width: 500px) {
      &:first-child {
        font-weight: 700;
      }
    }
  }

  @media only screen and (max-width: 858px) {
    margin: 0 auto;
    text-align: center;
  }
`
